import React from "react";

interface DohopLoadingSpinnerProps {
    message?: string;
}

const DohopLoadingSpinner: React.FC<DohopLoadingSpinnerProps> = ({
    message = "Searching for the best flights...",
}) => {
    return (
        <div className="flex flex-col items-center justify-center py-16">
            <div className="relative">
                {/* Outer ring */}
                <div className="w-16 h-16 border-4 border-dohop-ice rounded-full"></div>
                {/* Spinning ring */}
                <div className="absolute top-0 left-0 w-16 h-16 border-4 border-transparent border-t-dohop-blue rounded-full animate-spin"></div>
                {/* Plane icon in center */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <svg
                        className="w-6 h-6 text-dohop-blue"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
                    </svg>
                </div>
            </div>
            <p className="mt-4 text-dohop-text font-medium">{message}</p>
            <p className="mt-1 text-sm text-gray-500">
                We're searching hundreds of airlines to find you the best deals
            </p>
        </div>
    );
};

export default DohopLoadingSpinner;
